export default {"src":"/_next/static/media/bagel.c6c27afd.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};